/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: oermwjefjidrRRHcrxyCjQ
// Component: ZDk8OKbbuW

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  hasVariant,
  PlasmicIcon as PlasmicIcon__,
  renderPlasmicSlot,
  SingleBooleanChoiceArg,
  StrictProps,
  useDollarState,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import Button from "../../components/widgets/Button"; // plasmic-import: SEF-sRmSoqV5c/component
import NewComponentItem from "../../components/widgets/NewComponentItem"; // plasmic-import: csXhXQDIqh/component
import NewComponentSection from "../../components/widgets/NewComponentSection"; // plasmic-import: 3_QVitiqMh/component
import Textbox from "../../components/widgets/Textbox"; // plasmic-import: pA22NEzDCsn_/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: oermwjefjidrRRHcrxyCjQ/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import "./plasmic_plasmic_kit_new_component.css"; // plasmic-import: oermwjefjidrRRHcrxyCjQ/projectcss
import sty from "./PlasmicNewComponentModal.module.css"; // plasmic-import: ZDk8OKbbuW/css

import eyeSvgZxKyHRa6Q6Pa from "../plasmic_kit_design_system/images/eyeSvg.svg"; // plasmic-import: Zx-kyHRa6Q6PA/picture
import ArrowRightSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__ArrowRightSvg"; // plasmic-import: 9Jv8jb253/icon
import ChevronDownSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__ChevronDownSvg"; // plasmic-import: xZrB9_0ir/icon
import ChevronRightSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__ChevronRightSvg"; // plasmic-import: HBGx-zeiX/icon
import CloseSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__CloseSvg"; // plasmic-import: DhvEHyCHT/icon
import SearchSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__SearchSvg"; // plasmic-import: R5DLz11OA/icon

createPlasmicElementProxy;

export type PlasmicNewComponentModal__VariantMembers = {
  showTemplates: "showTemplates";
  isPage: "isPage";
};
export type PlasmicNewComponentModal__VariantsArgs = {
  showTemplates?: SingleBooleanChoiceArg<"showTemplates">;
  isPage?: SingleBooleanChoiceArg<"isPage">;
};
type VariantPropType = keyof PlasmicNewComponentModal__VariantsArgs;
export const PlasmicNewComponentModal__VariantProps =
  new Array<VariantPropType>("showTemplates", "isPage");

export type PlasmicNewComponentModal__ArgsType = { children?: React.ReactNode };
type ArgPropType = keyof PlasmicNewComponentModal__ArgsType;
export const PlasmicNewComponentModal__ArgProps = new Array<ArgPropType>(
  "children"
);

export type PlasmicNewComponentModal__OverridesType = {
  root?: Flex__<"div">;
  body?: Flex__<"div">;
  nameSection?: Flex__<"div">;
  nameInput?: Flex__<typeof Textbox>;
  expander?: Flex__<"button">;
  sections?: Flex__<"div">;
  footer?: Flex__<"div">;
  cancelButton?: Flex__<typeof Button>;
  submitButton?: Flex__<typeof Button>;
};

export interface DefaultNewComponentModalProps {
  children?: React.ReactNode;
  showTemplates?: SingleBooleanChoiceArg<"showTemplates">;
  isPage?: SingleBooleanChoiceArg<"isPage">;
  className?: string;
}

const $$ = {};

function PlasmicNewComponentModal__RenderFunc(props: {
  variants: PlasmicNewComponentModal__VariantsArgs;
  args: PlasmicNewComponentModal__ArgsType;
  overrides: PlasmicNewComponentModal__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "showTemplates",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          $props.showTemplates,
      },
      {
        path: "isPage",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.isPage,
      },
    ],
    [$props, $ctx, $refs]
  );

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs,
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_oermwjefjidrRRHcrxyCjQ",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root,
        {
          [sty.rootisPage]: hasVariant($state, "isPage", "isPage"),
          [sty.rootshowTemplates]: hasVariant(
            $state,
            "showTemplates",
            "showTemplates"
          ),
        }
      )}
    >
      <div
        data-plasmic-name={"body"}
        data-plasmic-override={overrides.body}
        className={classNames("all", sty.body, {
          [sty.bodyshowTemplates]: hasVariant(
            $state,
            "showTemplates",
            "showTemplates"
          ),
        })}
      >
        <div
          data-plasmic-name={"nameSection"}
          data-plasmic-override={overrides.nameSection}
          className={classNames("all", sty.nameSection)}
        >
          <div
            className={classNames("all", "__wab_text", sty.text__awiw5, {
              [sty.textisPage__awiw5GMsds]: hasVariant(
                $state,
                "isPage",
                "isPage"
              ),
            })}
          >
            {hasVariant($state, "isPage", "isPage")
              ? "Name for the new page?"
              : "Name for the new component?"}
          </div>
          <Textbox
            data-plasmic-name={"nameInput"}
            data-plasmic-override={overrides.nameInput}
            className={classNames("__wab_instance", sty.nameInput, {
              [sty.nameInputisPage]: hasVariant($state, "isPage", "isPage"),
            })}
            placeholder={
              hasVariant($state, "isPage", "isPage")
                ? "New page name…"
                : "New component name…"
            }
            prefixIcon={
              <SearchSvgIcon
                className={classNames("all", sty.svg___4IPyR)}
                role={"img"}
              />
            }
            styleType={["bordered"]}
            suffixIcon={
              <CloseSvgIcon
                className={classNames("all", sty.svg__haFhz)}
                role={"img"}
              />
            }
          />
        </div>
        <button
          data-plasmic-name={"expander"}
          data-plasmic-override={overrides.expander}
          className={classNames(
            "all",
            "button",
            "button__oermw",
            sty.expander,
            {
              [sty.expandershowTemplates]: hasVariant(
                $state,
                "showTemplates",
                "showTemplates"
              ),
            }
          )}
          ref={(ref) => {
            $refs["expander"] = ref;
          }}
        >
          <PlasmicIcon__
            PlasmicIconType={
              hasVariant($state, "showTemplates", "showTemplates")
                ? ChevronDownSvgIcon
                : ChevronRightSvgIcon
            }
            className={classNames("all", sty.svg__nc1Yg, {
              [sty.svgshowTemplates__nc1YgChkSp]: hasVariant(
                $state,
                "showTemplates",
                "showTemplates"
              ),
            })}
            role={"img"}
          />

          <div
            className={classNames("all", "__wab_text", sty.text__hBmC, {
              [sty.textshowTemplates__hBmCChkSp]: hasVariant(
                $state,
                "showTemplates",
                "showTemplates"
              ),
            })}
          >
            {hasVariant($state, "showTemplates", "showTemplates")
              ? "Hide component templates."
              : "Pick from a component template\u2026"}
          </div>
        </button>
      </div>
      {(
        hasVariant($state, "isPage", "isPage")
          ? true
          : hasVariant($state, "showTemplates", "showTemplates")
          ? true
          : false
      ) ? (
        <div
          data-plasmic-name={"sections"}
          data-plasmic-override={overrides.sections}
          className={classNames("all", sty.sections, {
            [sty.sectionsisPage]: hasVariant($state, "isPage", "isPage"),
            [sty.sectionsshowTemplates]: hasVariant(
              $state,
              "showTemplates",
              "showTemplates"
            ),
          })}
        >
          {renderPlasmicSlot({
            defaultContents: (
              <React.Fragment>
                <NewComponentSection
                  className={classNames(
                    "__wab_instance",
                    sty.newComponentSection__tgVaw
                  )}
                  hideTitle={true}
                >
                  <NewComponentItem
                    className={classNames(
                      "__wab_instance",
                      sty.newComponentItem__dnmm0
                    )}
                    controls={
                      <img
                        alt={""}
                        className={classNames(
                          "all",
                          "img",
                          "img__oermw",
                          sty.img__cr7As
                        )}
                        loading={"lazy"}
                        src={eyeSvgZxKyHRa6Q6Pa}
                      />
                    }
                  />
                </NewComponentSection>
                <NewComponentSection
                  className={classNames(
                    "__wab_instance",
                    sty.newComponentSection__nwPi
                  )}
                  title={
                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text__kuCq7
                      )}
                    >
                      {"Section title"}
                    </div>
                  }
                >
                  <NewComponentItem
                    className={classNames(
                      "__wab_instance",
                      sty.newComponentItem__rnlot
                    )}
                    controls={
                      <img
                        alt={""}
                        className={classNames(
                          "all",
                          "img",
                          "img__oermw",
                          sty.img___8Cygz
                        )}
                        loading={"lazy"}
                        src={eyeSvgZxKyHRa6Q6Pa}
                      />
                    }
                  />

                  <NewComponentItem
                    className={classNames(
                      "__wab_instance",
                      sty.newComponentItem__yWQs
                    )}
                    controls={
                      <img
                        alt={""}
                        className={classNames(
                          "all",
                          "img",
                          "img__oermw",
                          sty.img__jrMaZ
                        )}
                        loading={"lazy"}
                        src={eyeSvgZxKyHRa6Q6Pa}
                      />
                    }
                  />

                  <NewComponentItem
                    className={classNames(
                      "__wab_instance",
                      sty.newComponentItem___7WyKu
                    )}
                    controls={
                      <img
                        alt={""}
                        className={classNames(
                          "all",
                          "img",
                          "img__oermw",
                          sty.img__op150
                        )}
                        loading={"lazy"}
                        src={eyeSvgZxKyHRa6Q6Pa}
                      />
                    }
                  />

                  {(hasVariant($state, "isPage", "isPage") ? true : false) ? (
                    <NewComponentItem
                      className={classNames(
                        "__wab_instance",
                        sty.newComponentItem___9Dmb,
                        {
                          [sty.newComponentItemisPage___9DmbGMsds]: hasVariant(
                            $state,
                            "isPage",
                            "isPage"
                          ),
                        }
                      )}
                      controls={
                        <img
                          alt={""}
                          className={classNames(
                            "all",
                            "img",
                            "img__oermw",
                            sty.img__c82Hx
                          )}
                          loading={"lazy"}
                          src={eyeSvgZxKyHRa6Q6Pa}
                        />
                      }
                    />
                  ) : null}
                </NewComponentSection>
              </React.Fragment>
            ),
            value: args.children,
          })}
        </div>
      ) : null}
      <div
        data-plasmic-name={"footer"}
        data-plasmic-override={overrides.footer}
        className={classNames("all", sty.footer, {
          [sty.footerisPage]: hasVariant($state, "isPage", "isPage"),
          [sty.footershowTemplates]: hasVariant(
            $state,
            "showTemplates",
            "showTemplates"
          ),
        })}
      >
        <div className={classNames("all", sty.freeBox__yh2CX)}>
          <Button
            data-plasmic-name={"cancelButton"}
            data-plasmic-override={overrides.cancelButton}
            endIcon={
              <ChevronDownSvgIcon
                className={classNames("all", sty.svg__usoAe)}
                role={"img"}
              />
            }
            size={"wide"}
            startIcon={
              <ArrowRightSvgIcon
                className={classNames("all", sty.svg__sqtjl)}
                role={"img"}
              />
            }
            type={["secondary"]}
          >
            {"Cancel"}
          </Button>
        </div>
        <div
          className={classNames("all", sty.freeBox___9YjEg, {
            [sty.freeBoxisPage___9YjEgGMsds]: hasVariant(
              $state,
              "isPage",
              "isPage"
            ),
          })}
        >
          <Button
            data-plasmic-name={"submitButton"}
            data-plasmic-override={overrides.submitButton}
            className={classNames("__wab_instance", sty.submitButton)}
            endIcon={
              <ChevronDownSvgIcon
                className={classNames("all", sty.svg__aMluO)}
                role={"img"}
              />
            }
            size={"wide"}
            startIcon={
              <ArrowRightSvgIcon
                className={classNames("all", sty.svg__vy7Em)}
                role={"img"}
              />
            }
            type={["primary"]}
          >
            <div
              className={classNames("all", "__wab_text", sty.text__drisI, {
                [sty.textisPage__drisIgMsds]: hasVariant(
                  $state,
                  "isPage",
                  "isPage"
                ),
              })}
            >
              {hasVariant($state, "isPage", "isPage")
                ? "Create page"
                : "Create component"}
            </div>
          </Button>
        </div>
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "body",
    "nameSection",
    "nameInput",
    "expander",
    "sections",
    "footer",
    "cancelButton",
    "submitButton",
  ],
  body: ["body", "nameSection", "nameInput", "expander"],
  nameSection: ["nameSection", "nameInput"],
  nameInput: ["nameInput"],
  expander: ["expander"],
  sections: ["sections"],
  footer: ["footer", "cancelButton", "submitButton"],
  cancelButton: ["cancelButton"],
  submitButton: ["submitButton"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  body: "div";
  nameSection: "div";
  nameInput: typeof Textbox;
  expander: "button";
  sections: "div";
  footer: "div";
  cancelButton: typeof Button;
  submitButton: typeof Button;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicNewComponentModal__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicNewComponentModal__VariantsArgs;
    args?: PlasmicNewComponentModal__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicNewComponentModal__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicNewComponentModal__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicNewComponentModal__ArgProps,
          internalVariantPropNames: PlasmicNewComponentModal__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicNewComponentModal__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicNewComponentModal";
  } else {
    func.displayName = `PlasmicNewComponentModal.${nodeName}`;
  }
  return func;
}

export const PlasmicNewComponentModal = Object.assign(
  // Top-level PlasmicNewComponentModal renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    body: makeNodeComponent("body"),
    nameSection: makeNodeComponent("nameSection"),
    nameInput: makeNodeComponent("nameInput"),
    expander: makeNodeComponent("expander"),
    sections: makeNodeComponent("sections"),
    footer: makeNodeComponent("footer"),
    cancelButton: makeNodeComponent("cancelButton"),
    submitButton: makeNodeComponent("submitButton"),

    // Metadata about props expected for PlasmicNewComponentModal
    internalVariantProps: PlasmicNewComponentModal__VariantProps,
    internalArgProps: PlasmicNewComponentModal__ArgProps,
  }
);

export default PlasmicNewComponentModal;
/* prettier-ignore-end */
